import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { useSetSnackbarGlobalError } from '@tempo-io/fim3-components';

export function useErrorHandlingMutation<
  TData = unknown,
  TError = unknown,
  TVariables = void,
  TContext = unknown,
>({
  mutationFn,
  ...options
}: UseMutationOptions<TData, TError, TVariables, TContext>): UseMutationResult<
  TData,
  TError,
  TVariables,
  TContext
> {
  const setSnackbarGlobalError = useSetSnackbarGlobalError();
  options ??= {};

  if (options.onError === undefined) {
    options.onError = (error, variables) => setSnackbarGlobalError(error, variables);
  }

  return useMutation({ mutationFn, ...options });
}
